import { render } from "./MassUpdateEmailModal.vue?vue&type=template&id=bb78f43c&scoped=true"
import script from "./MassUpdateEmailModal.vue?vue&type=script&lang=js"
export * from "./MassUpdateEmailModal.vue?vue&type=script&lang=js"

import "./MassUpdateEmailModal.vue?vue&type=style&index=0&id=bb78f43c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb78f43c"]])

export default __exports__